import { jsxs as a, jsx as t } from "react/jsx-runtime";
function l({
  title: e,
  children: x
}) {
  return /* @__PURE__ */ a("div", { className: "max-w-2xl mx-auto mt-8 text-center ", children: [
    /* @__PURE__ */ t("h2", { className: "text-4xl font-bold tracking-tight text-brand sm:text-6xl", children: e }),
    /* @__PURE__ */ t("p", { className: "mt-6 text-lg leading-8 text-gray-600", children: x })
  ] });
}
export {
  l as HeroPage
};
